// Traduit une suggestion en paramètres d'URL pour /offres_vie.
// Les filtres vivent dans l'URL : revenir sur "Offres" (sans paramètres) remet tout à zéro.
export const suggestionToParams = (s) => {
    switch (s.kind) {
        case 'pays':
            return { country: s.label };
        case 'secteur':
            return { sector: s.label };
        default:
            return { search: s.label };
    }
};

export const buildOffersUrl = (params) => {
    const qs = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v) qs.set(k, v);
    });
    const str = qs.toString();
    return str ? `/offres_vie?${str}` : '/offres_vie';
};

export const KIND_LABELS = {
    pays: 'Pays',
    ville: 'Villes',
    entreprise: 'Entreprises',
    secteur: 'Secteurs',
};
